<template>
  <footer v-if="content && content.settings && content.settings.site">
    <section id="footer" class="container bg-color-white px-5 py-5 mt-5">
      <div class="row justify-content-between align-items-start">
        <div class="col-12 col-lg-3">
          <h2 class="font-w-900 font-s-21 text-color-theme-dark mb-3">
            ثریا مارکت
          </h2>
          <p
            class="font-w-400 font-s-14 text-color-theme-dark lineheight2 text-justify m-0"
            v-if="content"
          >
            {{ content.settings.site.footer_about }}
          </p>
          <div>
            <h3
              class="font-w-800 font-s-16 text-color-theme-dark custom-border-right mb-3 mt-3"
            >
              فضای مجازی
            </h3>
            <SocialNetworks />
          </div>
        </div>
        <div class="col-12 col-lg-2 mt-4 mt-lg-0">
          <h3
            class="font-w-800 font-s-16 text-color-theme-dark custom-border-right mb-3"
          >
            تماس با ما
          </h3>
          <div>
            <span class="font-w-700 font-s-12 text-color-theme-dark"
              >آدرس :</span
            >
            <div>
              <address
                class="font-w-400 font-s-12 text-color-theme-dark"
                v-if="!loading"
              >
                {{ content.settings.site.address }}
              </address>
              <b-skeleton v-else width="270px" />
            </div>
          </div>
          <div>
            <span class="font-w-700 font-s-12 text-color-theme-dark"
              >شماره تماس :</span
            >
            <div>
              <template v-if="!loading">
                <pre class="font-w-400 font-s-12 text-color-theme-dark">{{
                  content.settings.site.mobile.split(/\D+/g).join('\n'),
                }}</pre>
              </template>
              <template v-else>
                <span><b-skeleton width="105px" /></span>
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 mt-4 mt-lg-0">
          <h3
            class="font-w-800 font-s-16 text-color-theme-dark custom-border-right mb-3"
          >
            برای بروزرسانی ثبت نام کنید
          </h3>
          <div>
            <form @submit.prevent="sendEmail">
              <div
                class="d-flex align-items-center flex-nowrap bg-color-white border-r-24 newsletter-shadow"
              >
                <input
                  class="w-100 bg-transparent text-color-grey1 font-w-500 font-s-10 border-0 py-2 pr-3"
                  placeholder="ایمیل خودرا وارد کنید ..."
                  type="email"
                />
                <button
                  class="text-color-white font-w-700 font-s-12 border-r-24 py-2 px-4 bg-color-theme5"
                  type="submit"
                >
                  ارسال
                </button>
              </div>
            </form>
            <p class="font-w-400 font-s-10 text-color-grey1 m-0 pt-3">
              برای دریافت اخبار و به روز رسانی ها با آدرس ایمیل خود ثبت نام کنید
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-end gap-5 mt-3">
            <div
              style="width: 80px; height: 80px; background-color: #aaaaaa36"
              class="border-r-2"
            >
              <!-- <a
                target="_blank"
                href="https://trustseal.enamad.ir/?id=513813&Code=0jck2CMKfcZFgOhXycTKwX8Evx24KU5G"
                ><img
                  class="w-100"
                  referrerpolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=513813&Code=0jck2CMKfcZFgOhXycTKwX8Evx24KU5G"
                  alt=""
                  style="cursor: pointer"
                  code="0jck2CMKfcZFgOhXycTKwX8Evx24KU5G"
              /></a> -->
              <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=638817&Code=YFvFDxzua6o3hwZkcbwjyYR2gT4FPWDi'>
               <img class="w-100" referrerpolicy='origin' src='/assets/images/ENAMADpng.parspng.com_ (1).png' alt='enamad' style='cursor:pointer' code='YFvFDxzua6o3hwZkcbwjyYR2gT4FPWDi'>
              </a>
            </div>
            <div
              style="width: 80px; height: 80px; background-color: #aaaaaa36"
              class="border-r-2"
            ></div>
            <div
              style="width: 80px; height: 80px; background-color: #aaaaaa36"
              class="border-r-2"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="d-flex align-items-center justify-content-between flex-wrap gap-10 border-top pt-3 mt-3"
      >
        <ul
          class="d-flex align-items-center gap-15 m-0"
          v-if="content.menu && content.menu.footer"
        >
          <li
            class="font-w-400 font-s-13 text-color-theme-grey1"
            v-for="(item, index) in content.menu.footer"
            :key="index"
          >
            <DynamicLinker :item="item">{{ item.title }}</DynamicLinker>
          </li>
        </ul>
        <div class="d-flex align-items-center">
          <p class="font-w-400 font-s-11 text-color-theme-grey1 m-0">
            طراحی شده در گروه
          </p>
          <a
            class="font-w-400 font-s-11 text-color-theme-grey1 pr-1"
            href="https://shetabit.com"
            target="_blank"
          >
            شتاب
          </a>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { BSkeleton } from "bootstrap-vue";
import findUrl from "@/libraries/links/LinkResolver";
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker.vue";
import SocialNetworks from "@/parts/Front/components/shared/SocialNetworks.vue";
export default {
  name: "Footer",
  components: {
    SocialNetworks,
    DynamicLinker,
    BSkeleton,
  },
  computed: {
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
  data() {
    return {
      email: null,
      disabled: false,
      phoneNumber: null,
    };
  },
  methods: {
    findUrl,
    sendEmail() {
      if (!this.email) {
        return window.swal({
          title: "خطا!",
          text: "لطفا ایمیل خود را وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      } else if (!this.validEmail(this.email)) {
        return window.swal({
          title: "خطا!",
          text: "لطفا فرمت ایمیل خود را به درستی وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      }
      const fromData = new FormData();
      fromData.append("email", this.email);
      this.disabled = true;
      this.$axios.post("/front/newsletters", fromData).then((response) => {
        this.disabled = false;
        this.email = null;
        window.swal({
          title: "تبریک",
          text: "ایمیل شما برای عضویت در خبرنامه ما ثبت سیستم شد",
          icon: "success",
          timer: 2000,
        });
      });
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>
<style scoped>
#footer {
  border-radius: 12px 12px 0 0;
}
#footer .custom-border-right {
  border-right: 3px solid var(--color-theme);
  padding-right: 5px;
}
#footer .newsletter-shadow {
  box-shadow: 0px 0px 37px 5px #bababa63;
}
</style>
